module.exports = __webpack_public_path__ + "static/img/menu-product-wrightinTwo.9410ae41.png";